import { FC } from 'react';
import Loading from '../components/common/loading/Loading';
import UserEditForm from '../components/users/UserEditForm';
import { useTypedSelector } from '../hooks/useTypedSelector';
import { WrapInLayout } from '../layouts';
import { getCurrentUser } from '../store/authSlice';

const AccountPage: FC = () => {
  const user = useTypedSelector(getCurrentUser());

  return (
    <WrapInLayout title="Your Account" layout="portal">
      {!user
        ? <Loading />
        : <UserEditForm user={user} />
      }        
    </WrapInLayout>
  );
};

export default AccountPage;
